import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { catalog } from '../language/catalog';

i18n
  // // detect user language
  // // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: catalog.resources,
    overloadTranslationOptionHandler: (args) => {
      const key = args[0];
      if (args.length === 1) {
        return { defaultValue: key };
      }
      const second = args[1];
      if (typeof second === 'string') {
        return { defaultValue: second };
      }
      if (typeof second === 'object' && second !== null) {
        return { ...second, defaultValue: second.defaultValue ?? key };
      }
      return { defaultValue: key };
    },
    parseMissingKeyHandler: (key) => {
      return key.split('.').pop();
    },
  });

export default i18n;
